import { Link } from 'react-router-dom';

const AnalyticsRAHome = () => {
  return (
    <div className="analytics-ra-home">
      <h2>Аналитика оценок РА</h2>
      <div className="buttons-container" style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
        <Link to="/analytics-ra/project" className="btn btn-primary">
          Аналитика по проекту
        </Link>
        <Link to="/analytics-ra/summary" className="btn btn-primary">
          Сводная аналитика
        </Link>
      </div>
    </div>
  );
};

export default AnalyticsRAHome;
